import { useState } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

type PasswordFieldProps = {
  id: string;
  label: string;
  registration: UseFormRegisterReturn;
  autoComplete: 'current-password' | 'new-password';
  error?: string | undefined;
};

export function PasswordField({
  id,
  label,
  registration,
  autoComplete,
  error,
}: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);
  const errorId = `${id}-error`;
  return (
    <label className="auth-field" htmlFor={id}>
      <span>{label}</span>
      <span className="password-input-wrap">
        <input
          id={id}
          className="p-inputtext p-component"
          type={visible ? 'text' : 'password'}
          autoComplete={autoComplete}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
          {...registration}
        />
        <button
          type="button"
          aria-label={visible ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`}
          onClick={() => setVisible((current) => !current)}
        >
          <i className={visible ? 'pi pi-eye-slash' : 'pi pi-eye'} aria-hidden="true" />
        </button>
      </span>
      {error && (
        <small id={errorId} role="alert">
          {error}
        </small>
      )}
    </label>
  );
}
